import React, { useCallback, useState } from 'react'
import images from 'Assets/Images'
import { MessageErrorInput } from 'Components/Message/Error/input'
import classNames from 'classnames'
import Info from '../../../Assets/Images/icons/info'

export const InputUnstyled = props => {
  const {
    id,
    placeholder,
    disabled = false,
    name,
    meta = {},
    input = {},
    validator,
    min,
    onKeyDown = () => {},
    value,
    inputClassName,
    hint,
    style,
  } = props
  const [showHint, setShowHint] = useState(false)
  // Some old components are still using "value" prop

  var onChange = props.onChange || input.onChange
  var onBlur = props.onBlur || input.onBlur
  const defaultValue =
    props.defaultValue !== undefined ? props.defaultValue : input.defaultValue

  const type = props.type || 'text'
  const className = `${
    props.className
  } ${type}-input-wrapper ${props.className || ''} ${
    hasError() ? 'has-error' : ''
  }`

  const handleChange = useCallback(
    e => {
      onChange && onChange(e)
    },
    [validator, onChange],
  )

  /**
   * Render label
   * @returns JSX.Element | null
   */
  function renderLabel(cypress_id) {
    const { label, id } = props

    return label ? (
      <div className="labelContainer">
        <div className={'labelBox'}>
          <label
            className="label"
            htmlFor={id}
            cypress_id={cypress_id ? `${cypress_id}-label` : ''}
          >
            {label}
          </label>
          {hint ? (
            <div>
              <div
                className={'hint'}
                style={showHint ? { display: 'block' } : { display: 'none' }}
              >
                {hint}
              </div>
              <div
                className={'infoIcon'}
                onMouseEnter={() => setShowHint(true)}
                onMouseLeave={() => setTimeout(() => setShowHint(false), 1000)}
              >
                <Info />
              </div>
            </div>
          ) : null}
        </div>
        <label>{renderError(props.error)}</label>
      </div>
    ) : null
  }

  /**
   * Render icon
   * @returns JSX.Element | null
   */
  function renderIcon() {
    const icon = props.icon
    let iconImage

    if (icon) {
      switch (icon) {
        case 'user':
          iconImage = images.userIcon
          break
        case 'password':
          iconImage = images.passwordIcon
          break
        case 'email':
          iconImage = images.emailIcon
          break
      }
    }

    return icon ? <img className="icon" src={iconImage} alt="icon" /> : null
  }

  /**
   * Input has error
   * @returns boolean
   */
  function hasError(error) {
    return props.error || (meta.touched && meta.error) || error
  }

  /**
   * Render field error
   * @returns JSX.Element | null
   */
  function renderError(error) {
    const inputError = meta.error || props.error || error

    return hasError(error) ? (
      <MessageErrorInput key="errorMessage" message={inputError} />
    ) : null
  }

  return [
    <div
      key={`input`}
      style={style}
      className={classNames({
        [inputClassName]: inputClassName,
        [className]: !inputClassName,
      })}
    >
      {renderLabel(props.cypress_id)}
      <input
        id={id}
        test-id={props['test-id']}
        name={name}
        disabled={disabled}
        defaultValue={defaultValue === undefined ? '' : defaultValue}
        placeholder={placeholder}
        type={type}
        min={min}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        value={value}
        className={classNames({
          [inputClassName]: inputClassName,
          'errorStyles': hasError(),
        })}
        cypress_id={props.cypress_id}
      />
      {renderIcon()}
    </div>,
  ]
}
